import React from "react";
import { Col } from "reactstrap";

const LinearProgressBar = ({ title, color = "#10b981", value }) => {
  const percent = Math.min(100, Math.max(0, Number(value) || 0));

  return (
    <Col lg>
      <div className="p-3 bg-white rounded-3 border border-light-subtle shadow-sm h-100 d-flex flex-column justify-content-center">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <span className="fw-semibold text-muted" style={{ fontSize: "13px" }}>
            {title}
          </span>
          <span className="fw-bold text-dark" style={{ fontSize: "14px" }}>
            {percent}%
          </span>
        </div>
        <div
          className="progress"
          style={{
            height: "8px",
            backgroundColor: "#f1f5f9",
            borderRadius: "4px",
          }}
        >
          <div
            className="progress-bar"
            role="progressbar"
            style={{
              width: `${percent}%`,
              backgroundColor: color,
              borderRadius: "4px",
              transition: "width 0.4s ease",
            }}
            aria-valuenow={percent}
            aria-valuemin="0"
            aria-valuemax="100"
          />
        </div>
      </div>
    </Col>
  );
};

export default LinearProgressBar;
